export default __webpack_public_path__ + "static/media/003-stroller.64a7eb00.png";